function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * IndexedDB cache utility for large application data
 * Can handle 40-50 MB easily (much larger than sessionStorage's 5-10 MB limit)
 */
var DB_NAME = 'rbac_cache';
var STORE_NAME = 'DATA_STORE';
var DB_VERSION = 1;
/**
 * Create object store if it doesn't exist
 */
var createObjectStoreIfNeeded = function createObjectStoreIfNeeded(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
    }
};
/**
 * Recreate database when object store is missing
 */
var recreateDatabase = function recreateDatabase() {
    return new Promise(function (resolve, reject) {
        var deleteRequest = indexedDB.deleteDatabase(DB_NAME);
        deleteRequest.onsuccess = function () {
            var retryRequest = indexedDB.open(DB_NAME, DB_VERSION);
            retryRequest.onerror = function () {
                return reject(new Error('Failed to recreate IndexedDB'));
            };
            retryRequest.onsuccess = function () {
                return resolve(retryRequest.result);
            };
            retryRequest.onupgradeneeded = function (event) {
                var newDb = event.target.result;
                createObjectStoreIfNeeded(newDb);
            };
        };
        deleteRequest.onerror = function () {
            return reject(new Error('Failed to delete corrupted IndexedDB'));
        };
    });
};
/**
 * Handle successful database open
 */
var handleDatabaseOpen = function handleDatabaseOpen(db, resolve, reject) {
    if (db.objectStoreNames.contains(STORE_NAME)) {
        resolve(db);
        return;
    }
    // Object store is missing, need to recreate database
    db.close();
    recreateDatabase().then(resolve)["catch"](reject);
};
/**
 * Open IndexedDB connection
 */
var openDB = function openDB() {
    return new Promise(function (resolve, reject) {
        var request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onerror = function () {
            var _request$error;
            return reject(new Error(((_request$error = request.error) === null || _request$error === void 0 ? void 0 : _request$error.message) || 'Failed to open IndexedDB'));
        };
        request.onsuccess = function () {
            handleDatabaseOpen(request.result, resolve, reject);
        };
        request.onupgradeneeded = function (event) {
            var db = event.target.result;
            createObjectStoreIfNeeded(db);
        };
    });
};
/**
 * Save data to IndexedDB cache
 */
export var saveToCache = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(key, data) {
        var db, transaction, store, cachedData, _t;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.p = _context.n) {
                    case 0:
                        _context.p = 0;
                        _context.n = 1;
                        return openDB();
                    case 1:
                        db = _context.v;
                        transaction = db.transaction(STORE_NAME, 'readwrite');
                        store = transaction.objectStore(STORE_NAME);
                        cachedData = {
                            data: data,
                            timestamp: Date.now()
                        };
                        return _context.a(2, new Promise(function (resolve, reject) {
                            var request = store.put(cachedData, key);
                            request.onsuccess = function () {
                                resolve();
                            };
                            request.onerror = function () {
                                var _request$error2;
                                return reject(new Error(((_request$error2 = request.error) === null || _request$error2 === void 0 ? void 0 : _request$error2.message) || 'Failed to save to cache'));
                            };
                        }));
                    case 2:
                        _context.p = 2;
                        _t = _context.v;
                        console.error('Failed to save to IndexedDB:', _t);
                        throw _t;
                    case 3:
                        return _context.a(2);
                }
        }, _callee, null, [[0, 2]]);
    }));
    return function saveToCache(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get data from IndexedDB cache
 * Returns cached data without expiration (persists until logout)
 */
export var getFromCache = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(key) {
        var db, transaction, store, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        _context2.p = 0;
                        _context2.n = 1;
                        return openDB();
                    case 1:
                        db = _context2.v;
                        transaction = db.transaction(STORE_NAME, 'readonly');
                        store = transaction.objectStore(STORE_NAME);
                        return _context2.a(2, new Promise(function (resolve, reject) {
                            var request = store.get(key);
                            request.onsuccess = function () {
                                var result = request.result;
                                if (!result) {
                                    resolve(null);
                                    return;
                                }
                                resolve(result.data);
                            };
                            request.onerror = function () {
                                var _request$error3;
                                return reject(new Error(((_request$error3 = request.error) === null || _request$error3 === void 0 ? void 0 : _request$error3.message) || 'Failed to get from cache'));
                            };
                        }));
                    case 2:
                        _context2.p = 2;
                        _t2 = _context2.v;
                        console.error('Failed to get from IndexedDB:', _t2);
                        return _context2.a(2, null);
                }
        }, _callee2, null, [[0, 2]]);
    }));
    return function getFromCache(_x3) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * Clear all cached data
 */
export var clearCache = /*#__PURE__*/ function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
        var db, transaction, store, _t3;
        return _regenerator().w(function (_context3) {
            while (1)
                switch (_context3.p = _context3.n) {
                    case 0:
                        _context3.p = 0;
                        _context3.n = 1;
                        return openDB();
                    case 1:
                        db = _context3.v;
                        transaction = db.transaction(STORE_NAME, 'readwrite');
                        store = transaction.objectStore(STORE_NAME);
                        return _context3.a(2, new Promise(function (resolve, reject) {
                            var request = store.clear();
                            request.onsuccess = function () {
                                resolve();
                            };
                            request.onerror = function () {
                                var _request$error4;
                                return reject(new Error(((_request$error4 = request.error) === null || _request$error4 === void 0 ? void 0 : _request$error4.message) || 'Failed to clear cache'));
                            };
                        }));
                    case 2:
                        _context3.p = 2;
                        _t3 = _context3.v;
                        console.error('Failed to clear IndexedDB:', _t3);
                        throw _t3;
                    case 3:
                        return _context3.a(2);
                }
        }, _callee3, null, [[0, 2]]);
    }));
    return function clearCache() {
        return _ref3.apply(this, arguments);
    };
}();
/**
 * Remove specific cached items by keys
 */
export var removeCacheKeys = /*#__PURE__*/ function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(keys) {
        var db, transaction, store, _t4;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.p = _context4.n) {
                    case 0:
                        _context4.p = 0;
                        _context4.n = 1;
                        return openDB();
                    case 1:
                        db = _context4.v;
                        transaction = db.transaction(STORE_NAME, 'readwrite');
                        store = transaction.objectStore(STORE_NAME);
                        return _context4.a(2, new Promise(function (resolve) {
                            var total = keys.length;
                            if (total === 0) {
                                resolve();
                                return;
                            }
                            var completed = 0;
                            var handleComplete = function handleComplete() {
                                completed++;
                                if (completed === total) {
                                    resolve();
                                }
                            };
                            var _iterator = _createForOfIteratorHelper(keys), _step;
                            try {
                                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                    var key = _step.value;
                                    var request = store["delete"](key);
                                    request.onsuccess = handleComplete;
                                    request.onerror = handleComplete; // Continue even if some delete operations failed
                                }
                            }
                            catch (err) {
                                _iterator.e(err);
                            }
                            finally {
                                _iterator.f();
                            }
                        }));
                    case 2:
                        _context4.p = 2;
                        _t4 = _context4.v;
                        console.error('Failed to remove cache keys:', _t4);
                        throw _t4;
                    case 3:
                        return _context4.a(2);
                }
        }, _callee4, null, [[0, 2]]);
    }));
    return function removeCacheKeys(_x4) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * Get cache size (approximate)
 */
export var getCacheSize = /*#__PURE__*/ function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
        var estimate, _t5;
        return _regenerator().w(function (_context5) {
            while (1)
                switch (_context5.p = _context5.n) {
                    case 0:
                        _context5.p = 0;
                        if (!('storage' in navigator && 'estimate' in navigator.storage)) {
                            _context5.n = 2;
                            break;
                        }
                        _context5.n = 1;
                        return navigator.storage.estimate();
                    case 1:
                        estimate = _context5.v;
                        return _context5.a(2, estimate.usage || 0);
                    case 2:
                        return _context5.a(2, 0);
                    case 3:
                        _context5.p = 3;
                        _t5 = _context5.v;
                        console.error('Failed to estimate cache size:', _t5);
                        return _context5.a(2, 0);
                }
        }, _callee5, null, [[0, 3]]);
    }));
    return function getCacheSize() {
        return _ref5.apply(this, arguments);
    };
}();
